import $ from "jquery";

const productSort = () => {
  const el = {
    woocommerceSortForm: ".woocommerce-ordering",
    woocommerceSortSelect: ".woocommerce-ordering > select",
    customSelect: ".custom-select",
    customOption: ".custom-option",
  };

  const init = () => {
    if (el.woocommerceSortForm.length === 0) return;

    handleOnClickCustomSelect();
    handleOnLoadCustomSelectElement();
    handleOnClickCustomSelectOption();
    handleOnClickOutsideSelect();

    // jQuery(document).on("wpf_ajax_success", function () {
    //   $(document).ready(() => {
    //     handleOnLoadCustomSelectElement();
    //   });
    // });
  };

  const handleOnLoadCustomSelectElement = () => {
    $(document).ready(() => {
      const selectElement = $(el.woocommerceSortSelect);
      const selectOptionData = selectElement
        .find("option")
        ?.map((index, optionItem) => {
          return {
            value: $(optionItem).val(),
            text: $(optionItem).text(),
            isActive: $(optionItem)?.attr("selected") ? true : false,
          };
        })
        .get();
      const activedSelectOption = selectOptionData?.find(
        (item) => item.isActive === true
      );

      $(el.woocommerceSortForm).append(`
            <div class="${el.customSelect?.replace(".", "")}">
                <p>${
                  activedSelectOption
                    ? activedSelectOption.text
                    : "Winkelbestelling"
                }</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"></path></svg>
            </div>
            <div class="${el.customOption?.replace(".", "")}">
                ${
                  selectOptionData
                    .map((optionDatum) => {
                      return `<div data-value="${optionDatum.value}" class="${
                        optionDatum.isActive && "active"
                      }">
                            ${optionDatum.text}
                        </div>`;
                    })
                    ?.join("") || ""
                }
            </div>
        `);
    });
  };

  const handleOnClickCustomSelect = () => {
    $(document).on("click", el.customSelect, (selectEvent) => {
      const customSelectElement = $(selectEvent.target);
      const parentWrapper = customSelectElement.closest(el.woocommerceSortForm);

      parentWrapper.toggleClass("opened");
    });
  };

  const handleOnClickOutsideSelect = () => {
    $(document).on("click", (clickEvent) => {
      if ($(clickEvent.target).closest(el.woocommerceSortForm).length === 0) {
        $(el.woocommerceSortForm).removeClass("opened");
      }
    });
  };

  const handleOnClickCustomSelectOption = () => {
    $(document).on("click", `${el.customOption} > div`, (selectEvent) => {
      const customSelectOptionElement = $(selectEvent.target);
      const parentWrapper = customSelectOptionElement.closest(
        el.woocommerceSortForm
      );
      const originalSelectElement = parentWrapper.find("select");
      const customSelectElement = parentWrapper.find(el.customSelect);

      parentWrapper.toggleClass("opened");
      originalSelectElement
        .val(customSelectOptionElement.data("value"))
        .change();
      console.log(originalSelectElement.val());
      customSelectElement.find("p").html(customSelectOptionElement.text());
      parentWrapper.submit();
    });
  };

  init();
};

try {
  productSort();
} catch (error) {
  console.log(error);
}
